export const dark = "#000000";
export const light = "white";
